module.exports = "https://trybtryb-legacy.web.app/img/blizzard.5e2edcb7.webp";